// extracted by mini-css-extract-plugin
export default {"container":"Part5Text_container__4Q-Ez"};